import React from 'react';
import MarcaPusah from './MarcaPusah';

// Pantallas neutras de la plataforma, sin colores de institución: se muestran antes de saber
// cuál es la institución activa o cuando la API no responde. Llevan la marca PUSAH.

export const PantallaCarga = ({ mensaje = 'Cargando…' }) => (
  <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-5">
    <MarcaPusah className="h-9 opacity-80" conEnlace={false} />
    <span
      className="block w-9 h-9 rounded-full border-4 border-gray-200 border-t-gray-500 animate-spin"
      aria-label="Cargando"
    />
    <p className="text-gray-400 text-sm">{mensaje}</p>
  </div>
);

export const PantallaError = ({ mensaje, onReintentar }) => (
  <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-8 gap-8">
    <MarcaPusah className="h-9" conEnlace={false} />
    <div className="bg-white rounded-2xl shadow-sm p-10 text-center max-w-md border border-gray-200">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-red-50 rounded-full mb-6">
        <svg className="h-8 w-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h1 className="text-2xl font-bold text-gray-900 mb-3">No se pudo cargar el sitio</h1>
      <p className="text-gray-500 mb-6">{mensaje}</p>
      {onReintentar && (
        <button
          type="button"
          onClick={onReintentar}
          className="inline-block px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
        >
          Reintentar
        </button>
      )}
    </div>
  </div>
);

export default PantallaCarga;
